module.exports = __webpack_public_path__ + "static/img/care-3.515f841.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/care-3.png
// module id = tMm2
// module chunks = 1